module.exports = __webpack_public_path__ + "img/ndaytrip_mt.7ac9c851.png";